module.exports = __webpack_public_path__ + "img/web1.7564139e.png";